/**
 * ProcessPanel — Dynamic Output mock for "Walk me through how you
 * deliver" (Rev 25 Phase 2 Loop I). 5-stage timeline per Home.html
 * artboard.
 */

const STAGES = [
  {
    n: "01",
    t: "Discover",
    d: "Two calls. We map the problem, not the feature list. Output: a one-page brief.",
  },
  {
    n: "02",
    t: "Design",
    d: "Token-driven mocks in your browser. You comment, we iterate, never round-trip a PDF.",
  },
  {
    n: "03",
    t: "Build",
    d: "Our team ships in weekly previews. AWS CDK, React, typed end-to-end, audit-loggable.",
  },
  {
    n: "04",
    t: "Launch",
    d: "Lighthouse ≥ 0.97 on all four. Real-hardware walk before we hand you the keys.",
  },
  {
    n: "05",
    t: "Operate",
    d: "Care plan picks up. Same engineer who built it answers when something blinks red.",
  },
];

export function ProcessPanel() {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
      {STAGES.map((s) => (
        <div
          key={s.n}
          className="rounded-nx2 border border-nx-line bg-nx-surface/60 p-3.5"
        >
          <div className="font-mono text-[10.5px] uppercase tracking-[0.18em] text-nx-accent">
            {s.n}
          </div>
          <h4 className="mt-2 font-display text-base font-semibold text-nx-text">
            {s.t}
          </h4>
          <p className="mt-1.5 text-[12.5px] leading-relaxed text-nx-text-dim">
            {s.d}
          </p>
        </div>
      ))}
    </div>
  );
}

export default ProcessPanel;
